// SPDX-FileCopyrightText: 2026 Sequent Tech Inc <legal@sequentech.io>
//
// SPDX-License-Identifier: AGPL-3.0-only
var parsed = new WeakMap();
/** The row's message, parsed once per row; null when it isn't JSON. */
export var logMessage = function (record) {
    var _a, _b;
    if (!record)
        return null;
    if (parsed.has(record))
        return (_a = parsed.get(record)) !== null && _a !== void 0 ? _a : null;
    var message = null;
    try {
        var value = JSON.parse((_b = record.message) !== null && _b !== void 0 ? _b : "");
        message = value && typeof value === "object" ? value : null;
    }
    catch (_c) {
        message = null;
    }
    parsed.set(record, message);
    return message;
};
var isObject = function (value) {
    return !!value && typeof value === "object" && !Array.isArray(value);
};
/**
 * The details of an entry whose body carries `details_json` (signing steps
 * and the scheduled outcome entries); null for every other entry.
 */
export var logDetails = function (message) {
    var _a;
    var body = (_a = message === null || message === void 0 ? void 0 : message.statement) === null || _a === void 0 ? void 0 : _a.body;
    if (!isObject(body))
        return null;
    for (var _i = 0, _b = Object.values(body); _i < _b.length; _i++) {
        var variant = _b[_i];
        if (isObject(variant) && typeof variant.details_json === "string") {
            try {
                var details = JSON.parse(variant.details_json);
                return isObject(details) ? details : null;
            }
            catch (_c) {
                return null;
            }
        }
    }
    return null;
};
export var isExplanation = function (value) {
    return isObject(value) && typeof value.outcome === "string" && Array.isArray(value.checks);
};
/** The explanation an outcome entry carries in its details, if any. */
export var outcomeExplanation = function (details) {
    if (!details)
        return null;
    if (isExplanation(details.explanation))
        return details.explanation;
    return isExplanation(details) ? details : null;
};
/** The `{before, after}` of a ScheduledOutcomeChanged entry, if both are explanations. */
export var outcomeChange = function (details) {
    return details && isExplanation(details.before) && isExplanation(details.after)
        ? { before: details.before, after: details.after }
        : null;
};
